import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { AbrirAtendimentoVinculadoController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AtendimentoVinculado/AtendimentosVinculadoControllers";
import { ListarComodosController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/Comodos/ComodosAssistencia";
import { ListarCanalAtendimentoContoller } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IVincularAtendimento } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoVinculado/AtendimentoVinculadoInterfaces";
import { ACESSOS } from "../../../../../Routes/Acessos";
import UnForm from "../../../../Form";

interface ICriarAtendimentoVinculadoProps {
    idCaso: number;
    setShow: (show: boolean) => void;
}

type ICriarAtendimentoVinculadoFormData = Pick<
    IVincularAtendimento,
    | "DS_CASO"
    | "ID_CATEGORIA_ATENDIMENTO"
    | "ID_TIPO_CANAL_ATENDIMENTO"
    | "ID_COMODOS"
>;

export default function CriarAtendimentoVinculado(
    props: ICriarAtendimentoVinculadoProps
) {
    const history = useHistory();
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const emccampMode =
        ID_ORGANIZACAO === "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const { execute, loading: criando } = useAsyncCallback(
        AbrirAtendimentoVinculadoController
    );

    const FormMethods = useForm();

    const { control } = FormMethods;
    const handleCriarAtendimentoVinculadoFormSubmit = (
        formData: ICriarAtendimentoVinculadoFormData
    ) => {
        execute({
            ...formData,
            ID_CASO_PAI: props.idCaso,
        }).then((res) => {
            props.setShow(false);
            const linkAtendimento =
                ACESSOS.ASSISTENCIA.TELAS.ATENDIMENTO.DS_LINK;
            history.push(linkAtendimento(res.IDResponse));
        });
    };
    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                handleSubmit={handleCriarAtendimentoVinculadoFormSubmit}
                usingContext
            >
                <UnForm.Textarea
                    name="DS_CASO"
                    noRezise
                    rows={4}
                    label="Descrição"
                    registerOptions={{
                        required: "Insira a descrição do atendimento",
                    }}
                />

                <label>Categoria de Atendimento</label>
                <UnForm.SelectCategoriaAtendimento
                    name="ID_CATEGORIA_ATENDIMENTO"
                    ID_MODULO={ACESSOS.ASSISTENCIA.ID_MODULO}
                    registerOptions={{
                        required: "Insira a categoria de atendimento",
                    }}
                />

                <UnForm.LazySelect
                    controller={listarCanalAtendimento}
                    getDS={(ca) => ca.DS_TIPO_CANAL_ATENDIMENTO}
                    getKeyValue={(ca) => ca.ID_TIPO_CANAL_ATENDIMENTO}
                    name="ID_TIPO_CANAL_ATENDIMENTO"
                    label="Canal de Atendimento"
                    registerOptions={{
                        required: "Insira o canal de atendimento",
                    }}
                />

                {emccampMode && (
                    <div className="mt-2">
                        <label>Cômodos</label>
                        <UnForm.LazySelect
                            placeholder="Cômodos"
                            controller={ListarComodosController}
                            getDS={(comodo) => comodo.DS_COMODO}
                            getKeyValue={(comodo) =>
                                comodo.ID_COMODO_ASSISTENCIA_TEC
                            }
                            registerOptions={{
                                required: "Insira um cômodo",
                            }}
                            control={control}
                            name="idComodos"
                        />
                    </div>
                )}

                <UnForm.SubmitButton
                    color="success"
                    wrapperClassName="w-100 mt-8"
                    className="w-100"
                    icon={faLink}
                    loading={criando}
                    disabled={criando}
                    loadingSize={"sm"}
                >
                    Criar Assistência Técnica
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
